module.exports = __webpack_public_path__ + "img/leaf7.579a5cf5.png";